import { useEffect, useState } from 'react';
import Select from 'components/shared/select';
import Icon from 'components/shared/icon';
import RichText from 'components/shared/richtext';
import styles from './subscription.module.scss';

const Subscription = ({ shopifyData, sellingPlan, setSellingPlan, resources }) => {
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState('one-time');
  const [showInfoPopup, setShowInfoPopup] = useState(false);
  const { subscription: subscriptionResources } = resources || {};

  const hasWebshop = resources?.settings?.localesWithWebshop?.onOrOff;

  useEffect(() => {
    if (!shopifyData?.sellingPlans) return;

    const selectOptions = shopifyData?.sellingPlans.map(({ id, options: sellingPlanOptions }) => ({
      value: id,
      text: `${sellingPlanOptions[0].name} ${sellingPlanOptions[0].value}`,
    }));

    setOptions(selectOptions);
  }, [shopifyData]);

  if (!shopifyData?.sellingPlans || !options?.length) return null;

  const InfoPopup = () => {
    if (!showInfoPopup) return null;
    return (
      <div className={styles.overlay}>
        <div className={styles.infoPopup}>
          <button
            type="button"
            className={styles.closeBtn}
            onClick={() => {
              setShowInfoPopup(false);
            }}
          >
            <Icon type="close" />
          </button>
          <div className={styles.title}>{subscriptionResources?.infoPopupTitle?.text}</div>
          <RichText
            text={subscriptionResources?.infoPopupContent?.text?.json}
            className={styles.message}
          />
          <button
            type="button"
            className={styles.buttonBlack}
            onClick={() => setShowInfoPopup(false)}
          >
            {subscriptionResources?.infoPopupCloseButtonText?.text}
          </button>
        </div>
      </div>
    );
  };

  const handleSelectChange = value => {
    const allSellingPlans = shopifyData?.sellingPlans;
    const selectedSllingPlan = allSellingPlans.find(s => s.id === value);
    setSellingPlan(selectedSllingPlan);
  };

  const handleOptionSelect = plan => {
    if (selected === plan) return;
    setSelected(plan);
    if (plan === 'subscription') {
      setSellingPlan(shopifyData?.sellingPlans[0]);
    } else {
      setSellingPlan(null);
    }
  };

  if (!hasWebshop) return null;

  return (
    <>
      <div className={styles.container}>
        <div className={styles.options}>
          <button
            className={styles.option}
            type="button"
            onClick={() => handleOptionSelect('one-time')}
          >
            <input
              className={styles.radio}
              type="radio"
              value="one-time"
              name="purchaseTipe"
              checked={selected === 'one-time'}
            />
            <p className={styles.label}>{subscriptionResources?.oneTimePurchaseLabel?.text}</p>
          </button>
          <button
            className={styles.option}
            type="button"
            onClick={() => handleOptionSelect('subscription')}
          >
            <input
              className={styles.radio}
              type="radio"
              value="subscription"
              name="purchaseTipe"
              checked={selected === 'subscription'}
            />
            <p className={styles.label}>{subscriptionResources?.ongoingSubscriptionsLabel?.text}</p>
            <Select
              className={styles.select}
              options={options}
              selected={sellingPlan?.id || options[0].value}
              disabled={selected !== 'subscription'}
              onChange={handleSelectChange}
            />
          </button>
        </div>
        <button type="button" className={styles.infoButton} onClick={() => setShowInfoPopup(true)}>
          {subscriptionResources?.infoButtonText?.text}
        </button>
      </div>

      <InfoPopup />
    </>
  );
};

export default Subscription;
